<template>
    <input :type="type" :placeholder="placeholder"/>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            required: true
        }
    }
}
</script>

<style scoped>
input {
  outline: none;
  border: none;
  height: 55px;
  padding: 18px 8px;
  border-bottom: 0.823px solid rgba(0, 0, 0, 0.8);
  font-size: 2.2rem;
}
</style>